import { createSelector } from 'reselect';
import isNil from 'lodash/isNil';
import each from 'lodash/each';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import difference from 'lodash/difference';
import { penceToPounds } from '$app/utils/util';
import {
  LINE_ITEMS_TABLE_DATA,
  LINE_ITEMS_PRICE_COLUMNS,
  TRANSPORTATION_FEE_TYPE,
  TRANSPORTATION_FEE_SKU,
  TRANSPORTATIION_FEE_TITLE,
  ADJUSTMENT_TYPE,
} from '../constants';
import { quoteState } from '../selectors';

const applyPenceToPounds = li =>
  each(pick(li, LINE_ITEMS_PRICE_COLUMNS), (v, k) => (li[k] = penceToPounds(v)));

const getAdjustmentFields = adjustment =>
  pickBy(
    adjustment,
    (val, key) =>
      !isNil(val) &&
      difference(LINE_ITEMS_TABLE_DATA, [
        'discount',
        'expires',
        'bookingId',
        'labourTime',
        'labourCost',
        'partsQuantity',
        'partsPrice',
        'fixedCostWithVAT',
      ]).includes(key)
  );

const prepareAdjustment = adjustment => {
  const li = getAdjustmentFields(adjustment);
  applyPenceToPounds(li);
  const { operationId, workSummary, title, parentId } = li;
  return Object.assign(li, {
    key: operationId,
    workOperation: { text: workSummary || title },
    className: 'adjustment-row',
    editable: !!parentId,
  });
};

export default function adjustmentSelector() {
  return createSelector(
    quoteState,
    state => {
      if (!state) return null;
      const adjustment = state.get('lineItems').find(li => li.get('type') === ADJUSTMENT_TYPE);
      if (!adjustment) return null;
      const li = prepareAdjustment(adjustment.toJS());
      li.children = li.subLineItems.map(prepareAdjustment);
      return li;
    }
  );
}

export function feeSelector() {
  return createSelector(
    quoteState,
    state => {
      if (!state) return [];

      const fee = state.get('lineItems')
        .filter(li => li.get('type') == 'fee');

      if (!fee) return [];

      return fee.toJS().map(item => ({
        workSummary: item.workSummary || item.title,
        garageCost: penceToPounds(item.garageCost),
        garageCostWithVat: penceToPounds(item.garageCostWithVat),
        className: ['footer-row'],
        editable: false,
        type: item.type,
        key: `fee-row-${item.operationId}`,
      }))
    });
};
